import styles from "./EventLogoAutoShrink.module.scss";
import { useRef } from "react";
import { useElementSize } from "../../../../utils/useElementSize";
import { TEventLogoType } from "../../EventLogo";

interface IProps {
    children: React.ReactNode;
    type: TEventLogoType;
}

const calculateScale = (wrapperWidth?: number, measurementWidth?: number) => {  
    if (!wrapperWidth || !measurementWidth) return 1;
    let scale = wrapperWidth / measurementWidth;
    if (scale > 1) scale = 1;
    return scale.toFixed(3);
}

export function EventLogoAutoShrink(props: IProps) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const measurementRef = useRef<HTMLDivElement>(null);

    const wrapperSize = useElementSize(wrapperRef);
    const measurementSize = useElementSize(measurementRef);

    const scale = calculateScale(wrapperSize?.width, measurementSize?.width);

    if (props.type === "PRINT") {
        return <>{props.children}</>;
    }

    return (
        <div
            className={styles.wrapper}
            ref={wrapperRef}
            style={
                {
                    "--event-logo-scale": scale,
                    "--event-logo-width": (measurementSize?.width || "0") + "px",
                    "--event-logo-height": (measurementSize?.height || "0") + "px",
                } as React.CSSProperties
            }
        >
            <div className={styles.displayWrapper}>
                <div className={styles.displayInnerWrapper}>{props.children}</div>
            </div>
            <div className={styles.measurementOnly} ref={measurementRef}>
                {props.children}
            </div>
            <div className={styles.takeSpace}></div>
        </div>
    );
}
